import { render, staticRenderFns } from "./ComparableAdvertsTaskStatus.vue?vue&type=template&id=41b891dc&"
import script from "./ComparableAdvertsTaskStatus.vue?vue&type=script&lang=js&"
export * from "./ComparableAdvertsTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports